import { useLocale } from '@ux/whitelabel';
import { jsx } from 'react/jsx-runtime';

const PureCurrencySymbol = _ref => {
  let {
    currency,
    className
  } = _ref;
  const locale = useLocale();
  const currencySymbol = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    maximumSignificantDigits: 1
  }).format(0).replace('0', '');
  return /*#__PURE__*/jsx("span", {
    className: className,
    children: currencySymbol
  });
};
var PureCurrencySymbol$1 = PureCurrencySymbol;

export { PureCurrencySymbol$1 as default };
